import { StorefrontPlugins } from '@engyalo/storefront-types'
import { Grid } from '@chakra-ui/core'
import HorizontalProduct from './plugins/HorizontalProduct'
import { CustomProduct } from './plugins/CustomProduct'
import { CustomProductFooter } from './plugins/CustomProductFooter'

export const plugins = {
  Catalogue: {
    container: Grid,
    props: {
      gridTemplateColumns: '1fr',
      gridRowGap: '0',
    },
  },
  CollectionProduct: {
    container: HorizontalProduct,
  },
  ProductDetailBody: {
    container: CustomProduct,
  },
  ProductAddToCart: {
    container: CustomProductFooter,
  },
} as StorefrontPlugins
